import { Check } from "lucide-react";

const facts = [
  "**Enterprise Engineering Expertise:** Deep experience building and operating large-scale, distributed systems optimized for performance, reliability, and scale",
  "**Platform-first Approach:** We design systems with a strong focus on integration, observability, and real-time data processing",
  "**Production-proven:** Systems running continuously in mission-critical enterprise environments, supporting demanding operational requirements",
  "**Long-term Partnerships:** We embed with engineering and architecture teams to deliver sustained value beyond initial delivery",
];

export const About = () => {
  return (
    <section id="about" className="relative py-24 md:py-32">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="font-mono text-xs uppercase tracking-widest text-primary mb-4">About Bane Tech</p>
            <h2 className="font-display text-3xl md:text-5xl font-bold leading-tight">
              An engineering company building{" "}
              <span className="text-gradient">high-performance enterprise platforms</span>.
            </h2>
            <p className="mt-6 text-muted-foreground text-lg leading-relaxed">
              Bane Tech is a software engineering company specialising in high-performance systems, real-time monitoring and enterprise-scale architectures.
              We design, build, and operate mission-critical platforms that deliver reliable, low-latency performance at scale.
            </p>
            <p className="mt-4 text-muted-foreground leading-relaxed text-lg">
              We work closely with enterprise teams across the full product lifecycle, from architecture and system design to production deployment and 24/7 operational support.
            </p>
          </div>

          <div className="relative">
            <div className="rounded-2xl border-gradient bg-card-gradient p-1">
              <div className="rounded-[14px] bg-surface p-8">
                <ul className="space-y-5">
                  {facts.map((f) => {
                    const match = f.match(/^\*\*(.+?)\*\*\s*(.*)$/);
                    return (
                      <li key={f} className="flex items-start gap-4">
                        <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 border border-primary/30">
                          <Check className="h-3.5 w-3.5 text-primary" strokeWidth={3} />
                        </span>
                        <span className="text-sm md:text-base text-muted-foreground">
                          {match ? (
                            <>
                              <span className="text-foreground/90">{match[1]}</span>{" "}
                              {match[2]}
                            </>
                          ) : (
                            f
                          )}
                        </span>
                      </li>
                    );
                  })}
                </ul>

                <div className="mt-8 pt-8 border-t border-border grid grid-cols-3 gap-4 text-center">
                  {[
                    { k: "10+", v: "Years experience" },
                    { k: "6", v: "Core products" },
                    { k: "EU", v: "Headquartered" },
                  ].map((s) => (
                    <div key={s.v}>
                      <div className="font-display text-2xl font-bold text-gradient">{s.k}</div>
                      <div className="text-xs text-muted-foreground mt-1">{s.v}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
